import  InstrumentMappingSearchCriteria  from '../InstrumentMapping/Models/InstrumentMappingSearchCriteraModel';
import InstrumentMappingsLookup from '../InstrumentMapping/Models/InstrumentMappingLookupModel';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { Data, Model, Utils } from '@singularsystems/neo-core';
import { AppService, Types } from '../../App/Services/AppService';
import CommandResult from '../../Common/Models/CommandResult';
import InstrumentMappingUpdate from '../InstrumentMapping/Models/InstrumentMappingUpdate';

export interface IInstrumentMappingApiClient {
    getPagedInstrumentMappings(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<InstrumentMappingSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<InstrumentMappingsLookup>>>;
    updateInstrumentMapping(payload: Model.PlainObject<InstrumentMappingUpdate>): AxiosPromise<Model.PlainObject<CommandResult>>;
}

@injectable()
export default class InstrumentMappingApiClient extends Data.ApiClientBase implements IInstrumentMappingApiClient {
    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/Instrument`)
    }

   public getPagedInstrumentMappings(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<InstrumentMappingSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<InstrumentMappingsLookup>>> {
        var response = this.axios.get(`${this.apiPath}/GetInstrumentMappingLookup?${Utils.getQueryString(payload)}`);
        return response;
    }

    public updateInstrumentMapping(payload: Model.PlainObject<InstrumentMappingUpdate>): AxiosPromise<Model.PlainObject<CommandResult>> {
        var response = this.axios.patch(`${this.apiPath}/UpdateInstrumentMappings`, payload);
        return response;
    }
}